import { WithStyles, withStyles } from '@mui/styles';
import classNames from 'classnames';
import React from 'react';
import Box from 'react-layout-components';

import styles from './PageContent.styles';

interface Props extends WithStyles<typeof styles> {
  className?: string;
  children: React.ReactNode;
}

function PageContent(props: Props) {
  const { className, children, classes } = props;
  return <Box className={classNames(classes.pageContent, className)}>{children}</Box>;
}

export default withStyles(styles)(PageContent);
